import { render } from "./ChatMessagesList.vue?vue&type=template&id=2a70cc71&scoped=true"
import script from "./ChatMessagesList.vue?vue&type=script&lang=ts"
export * from "./ChatMessagesList.vue?vue&type=script&lang=ts"

import "./ChatMessagesList.vue?vue&type=style&index=0&id=2a70cc71&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2a70cc71"

export default script